import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Avatar from '@material-ui/core/Avatar';
import Img from 'react-image';
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import {Person} from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center'
    },
    imgDiv: {
        marginRight: theme.spacing()
    },
    name: {
        fontWeight: 500
    },
    img: {
        width: 40,
        height: 'auto'
    },
    avatar: {
        backgroundColor: theme.palette.secondary.light
    }
}));

export default function PersonIdentification(props) {
    const { name, description, avatarImage } = props;
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.imgDiv}>
                <Avatar className={classes.avatar}>
                    <Img
                        className={classes.img}
                        src={avatarImage}
                        loader={<CircularProgress />}
                        unloader={<Person />}/>
                </Avatar>
            </div>
            <div>
                <Typography variant="body1" className={classes.name}>
                    {name}
                </Typography>
                {!_.isEmpty(description) && (
                    <Typography variant="body2">
                        {description}
                    </Typography>
                )}
            </div>
        </div>
    );
};

PersonIdentification.propTypes = {
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    avatarImage: PropTypes.string.isRequired
};